import { render, staticRenderFns } from "./RevokeOrDeclineAff.vue?vue&type=template&id=c5924c28&scoped=true&"
import script from "./RevokeOrDeclineAff.vue?vue&type=script&lang=tsx&"
export * from "./RevokeOrDeclineAff.vue?vue&type=script&lang=tsx&"
import style0 from "./RevokeOrDeclineAff.vue?vue&type=style&index=0&id=c5924c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5924c28",
  null
  
)

export default component.exports